(function(){'use strict';
var red=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function tr(n,p){p=p||{};try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:n},p))}catch(e){}
try{if(typeof gtag==='function')gtag('event',n,p)}catch(e){}
try{if(typeof fbq==='function')fbq('trackCustom',n,p)}catch(e){}}
window.erTrack=tr;tr('page_view',{page:location.pathname});

var nav=document.querySelector('[data-nav]'),bar=document.querySelector('[data-sbar]'),hero=document.querySelector('[data-hero]');
function sc(){if(nav)nav.classList.toggle('sk',window.scrollY>6);
if(bar)bar.classList.toggle('on',window.scrollY>(hero?hero.offsetHeight*.7:300))}
window.addEventListener('scroll',sc,{passive:true});sc();

var tg=document.querySelector('[data-tg]'),mm=document.querySelector('[data-mm]');
if(tg&&mm){tg.addEventListener('click',function(){var o=document.body.classList.toggle('mo');tg.setAttribute('aria-expanded',o?'true':'false')});
mm.addEventListener('click',function(e){if(e.target.closest('a')){document.body.classList.remove('mo');tg.setAttribute('aria-expanded','false')}})}

var rv=document.querySelectorAll('.rv');
if('IntersectionObserver'in window&&!red){var io=new IntersectionObserver(function(es){es.forEach(function(e){
if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -6% 0px',threshold:.08});
rv.forEach(function(e){io.observe(e)})}else{rv.forEach(function(e){e.classList.add('in')})}

document.querySelectorAll('[data-packs]').forEach(function(box){
var form=box.closest('form');if(!form)return;
var hid=form.querySelector('input[name="id"]');
var tot=form.querySelector('[data-o-tot]'),was=form.querySelector('[data-o-was]'),
    per=form.querySelector('[data-o-per]'),sav=form.querySelector('[data-o-sav]'),qtyL=form.querySelector('[data-o-qty]');
function apply(r){
 if(!r)return;
 if(hid)hid.value=r.value;
 if(tot)tot.textContent=r.dataset.tot||'';
 if(was){was.textContent=r.dataset.was||'';was.style.display=r.dataset.was?'':'none'}
 if(per)per.textContent=r.dataset.per||'';
 if(sav){sav.textContent=r.dataset.sav||'';sav.style.display=r.dataset.sav?'':'none'}
 if(qtyL)qtyL.textContent=r.dataset.qty||'';
}
box.addEventListener('change',function(e){
 var r=e.target;if(r&&r.name&&r.checked){apply(r);tr('pack_select',{pack:r.dataset.qty})}
});
apply(box.querySelector('input:checked'));
});

document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){
var id=a.getAttribute('href');if(!id||id==='#')return;var t=document.querySelector(id);if(!t)return;e.preventDefault();
window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-74,behavior:red?'auto':'smooth'})})});
document.querySelectorAll('[data-cta]').forEach(function(b){b.addEventListener('click',function(){tr('cta_click',{loc:b.getAttribute('data-cta')})})});
})();
